import React from "react";
import Swal from "sweetalert2";
import { useAdminState } from "../contexts/AdminContext";
import * as API from "../api/request";
import { Select } from "antd";
import _ from "lodash";

const Data = () => {
  const { admin, setAdmin } = useAdminState();

  const save = () => {
    let formData = new FormData();
    let validation = "";
    admin.data.article_id || (validation += "Гарчиг сонгоно уу.<br/>");
    admin.data.data_name || (validation += "Өгөгдлийн нэр бичнэ үү.<br/>");
    if (validation !== "") {
      Swal.fire({
        icon: "warning",
        html: validation,
      });
    } else {
      if (admin.data.files.length > 0) {
        admin.data.files.map((el) => formData.append("attaches", el));
        API.postAttachment(formData)
          .then((res) => {
            var result = [];
            res.uploads.map((el) => {
              return result.push({
                attachment_url: el.attachment_url,
                attachment_extension: el.attachment_extension,
                attachment_name: el.attachment_name,
              });
            });
            API.postData({
              article_id: admin.data.article_id,
              data_name: admin.data.data_name,
              url: admin.data.url,
              attachments: result,
            })
              .then((res) => {
                setAdmin({
                  type: "DATA_CHANGE_STATE",
                  data: { refresh: admin.data.refresh + 1, modal: false },
                });
                Swal.fire("Амжилттай", "Амжилттай бүртгэгдлээ.", "success");
              })
              .catch(() => {});
          })
          .catch(() => {});
      } else {
        API.postData({
          article_id: admin.data.article_id,
          data_name: admin.data.data_name,
          url: admin.data.url,
        })
          .then((res) => {
            setAdmin({
              type: "DATA_CHANGE_STATE",
              data: { refresh: admin.data.refresh + 1, modal: false },
            });
            Swal.fire("Амжилттай", "Амжилттай бүртгэгдлээ.", "success");
          })
          .catch(() => {});
      }
    }
  };

  const update = () => {
    let formData = new FormData();
    let validation = "";
    admin.data.article_id || (validation += "Гарчиг сонгоно уу.<br/>");
    admin.data.data_name || (validation += "Өгөгдлийн нэр бичнэ үү.<br/>");
    if (validation !== "") {
      Swal.fire({
        icon: "warning",
        html: validation,
      });
    } else {
      var filter_attach = admin.data.files.filter((el) => el.id === undefined);
      if (filter_attach.length > 0) {
        filter_attach.map((el) => formData.append("attaches", el));
        API.postAttachment(formData)
          .then((res) => {
            var result = [];
            var old_files = admin.data.files.filter(
              (el) => el.id !== undefined
            );
            if (old_files.length > 0) {
              old_files.map((el) => {
                return result.push({
                  attachment_url: el.attachment_url,
                  attachment_extension: el.attachment_extension,
                  attachment_name: el.attachment_name,
                });
              });
            }
            res.uploads.map((el) => {
              return result.push({
                attachment_url: el.attachment_url,
                attachment_extension: el.attachment_extension,
                attachment_name: el.attachment_name,
              });
            });
            API.putData(admin.data.id, {
              article_id: admin.data.article_id,
              data_name: admin.data.data_name,
              url: admin.data.url,
              attachments: result,
            })
              .then((res) => {
                setAdmin({
                  type: "DATA_CHANGE_STATE",
                  data: { refresh: admin.data.refresh + 1, modal: false },
                });
                Swal.fire("Амжилттай", "Амжилттай бүртгэгдлээ.", "success");
              })
              .catch(() => {
                Swal.fire(
                  "Анхаар",
                  "Бүртгэж чадсангүй дахин оролдоно уу!",
                  "warning"
                );
              });
          })
          .catch(() => {
            Swal.fire(
              "Анхаар",
              "Бүртгэж чадсангүй дахин оролдоно уу!",
              "warning"
            );
          });
      } else {
        var result = [];
        var old_files = admin.data.files.filter((el) => el.id !== undefined);
        if (old_files) {
          old_files.map((el) => {
            return result.push({
              attachment_url: el.attachment_url,
              attachment_extension: el.attachment_extension,
              attachment_name: el.attachment_name,
            });
          });
        }
        API.putData(admin.data.id, {
          article_id: admin.data.article_id,
          data_name: admin.data.data_name,
          url: admin.data.url,
          attachments: result,
        })
          .then((res) => {
            setAdmin({
              type: "DATA_CHANGE_STATE",
              data: { refresh: admin.data.refresh + 1, modal: false },
            });
            Swal.fire("Амжилттай", "Амжилттай бүртгэгдлээ.", "success");
          })
          .catch(() => {
            Swal.fire(
              "Анхаар",
              "Бүртгэж чадсангүй дахин оролдоно уу!",
              "warning"
            );
          });
      }
    }
  };

  const trash = (type, id) => {
    Swal.fire({
      title: "Та устгахдаа итгэлтэй байна уу?",
      text: "Сэргэх боломжгүйг анхаарна уу!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Тийм",
      cancelButtonText: "Үгүй",
    }).then((result) => {
      if (result.isConfirmed) {
        if (type === 0) {
          if (admin.data.files.length > 0) {
            setAdmin({
              type: "DATA_CHANGE_STATE",
              data: {
                files: admin.data.files.filter((el, index) => index !== id),
              },
            });
            Swal.fire("Амжилттай", "Амжилттай устгалаа.", "success");
          }
        } else {
          API.deleteAttachment(id)
            .then(() => {
              API.getOneData(admin.data.id)
                .then((res) => {
                  setAdmin({
                    type: "DATA_CHANGE_STATE",
                    data: {
                      files: res.attachments,
                      refresh: admin.data.refresh + 1,
                    },
                  });
                  Swal.fire("Амжилттай", "Амжилттай устгалаа.", "success");
                })
                .catch(() => {
                  Swal.fire(
                    "Анхаар",
                    "Хавсралт файлын жагсаалт татаж чадсангүй!",
                    "warning"
                  );
                });
            })
            .catch(() => {
              Swal.fire(
                "Анхаар",
                "Устгаж чадсангүй дахин оролдоно уу!",
                "warning"
              );
            });
        }
      }
    });
  };

  return (
    <div className={admin.data.modal ? "block" : "hidden"}>
      <div className="overflow-y-auto overflow-x-hidden fixed top-0 right-0 left-0 w-full h-modal h-full bg-black opacity-30 z-[61]"></div>
      <div
        className="fixed top-1/2 left-1/2 w-full max-w-[600px] h-auto z-[62]"
        style={{ transform: "translate(-50%, -50%)" }}
      >
        <div className="relative bg-white rounded-lg shadow">
          <div className="flex justify-between items-center px-4 py-2 rounded-t border-b">
            <div className="font-semibold text-gray-900">
              Өгөгдөл бүртгэх цонх
            </div>
            <button
              type="button"
              className="text-gray-400 bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm p-1.5 ml-auto inline-flex items-center"
              data-modal-toggle="defaultModal"
              onClick={() =>
                setAdmin({ type: "DATA_CHANGE_STATE", data: { modal: false } })
              }
            >
              <svg
                aria-hidden="true"
                className="w-5 h-5"
                fill="currentColor"
                viewBox="0 0 20 20"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  fillRule="evenodd"
                  d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                  clipRule="evenodd"
                />
              </svg>
            </button>
          </div>
          <div className="p-4">
            {/* body */}
            <div className="relative max-h-[calc(100vh-145px)] h-auto overflow-auto">
              <Select
                showSearch
                optionFilterProp="children"
                placeholder="Гарчиг сонгох"
                className="w-full"
                allowClear
                value={admin.data.article_id}
                onChange={(value) => {
                  setAdmin({
                    type: "DATA_CHANGE_STATE",
                    data: {
                      article_id: value,
                    },
                  });
                }}
                filterOption={(input, option) =>
                  (option?.label ?? "")
                    .toLowerCase()
                    .includes(input.toLowerCase())
                }
                options={_.map(admin.article.list, (el) => {
                  return { value: el.id, label: el.article_name };
                })}
              />
              <input
                type="text"
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-md focus:border-[#A3C050] block w-full p-2 focus:outline-none flex-1 mt-3"
                maxLength={500}
                placeholder="Өгөгдлийн нэр бичнэ үү"
                value={admin.data.data_name}
                onChange={(e) => {
                  setAdmin({
                    type: "DATA_CHANGE_STATE",
                    data: {
                      data_name: e.target.value,
                    },
                  });
                }}
              />
              <input
                type="text"
                className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-md focus:border-[#A3C050] block w-full p-2 focus:outline-none flex-1 mt-3"
                maxLength={500}
                placeholder="URL зам оруулна уу"
                value={admin.data.url}
                onChange={(e) => {
                  setAdmin({
                    type: "DATA_CHANGE_STATE",
                    data: {
                      url: e.target.value,
                    },
                  });
                }}
              />
              <div className="mt-3">
                <label
                  htmlFor="files"
                  className="py-1 px-2 flex items-center justify-center font-medium bg-gray-500 text-white rounded cursor-pointer w-[200px]"
                >
                  Файл сонгох
                  <i className="fa fa-upload ml-3 text-xs" />
                </label>
                <input
                  id="files"
                  type="file"
                  className="hidden"
                  accept=".doc,.docx,.pdf,.xlsx,.xls"
                  multiple={true}
                  onChange={(e) => {
                    var result = admin.data.files;
                    Object.entries(e.target.files).map((el) => {
                      return result.push(el[1]);
                    });
                    setAdmin({
                      type: "DATA_CHANGE_STATE",
                      data: { files: result },
                    });
                  }}
                />
              </div>
              {admin.data.files.length > 0 && (
                <table className="min-w-full mt-3">
                  <thead className="border-b">
                    <tr className="bg-gray-100">
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-2 py-2 text-center w-[50px]"
                      >
                        №
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-2 py-2 text-left"
                      >
                        Файлын нэр
                      </th>
                      <th
                        scope="col"
                        className="text-sm font-medium text-gray-900 px-2 py-2 text-center w-[50px]"
                      >
                        #
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {admin.data.files.map((el, index) => {
                      return (
                        <tr className="border-b" key={index}>
                          <td className="px-2 py-2 whitespace-nowrap text-sm font-medium text-gray-900 text-center w-[50px]">
                            {index + 1}
                          </td>
                          <td className="text-sm text-gray-900 font-light px-2 py-2">
                            {el.name ? el.name : el.attachment_name}
                          </td>
                          <td className="text-sm text-gray-900 font-light px-2 py-2 w-[50px] text-center">
                            <i
                              className="fa fa-trash text-red-700 cursor-pointer"
                              onClick={() => {
                                if (el.id) {
                                  trash("1", el.id);
                                } else {
                                  trash("0", index);
                                }
                              }}
                            />
                          </td>
                        </tr>
                      );
                    })}
                  </tbody>
                </table>
              )}
              <button
                className="py-1 px-2 flex items-center justify-center font-semibold text-[#A3C050] border-2 border-[#A3C050] rounded-md hover:bg-[#A3C050] hover:text-white focus:outline-none duration-300 w-full mt-3"
                onClick={() => {
                  if (admin.data.id === 0) {
                    save();
                  } else {
                    update();
                  }
                }}
              >
                Хадгалах
              </button>
            </div>
            {/* body */}
            <hr className="-mx-4 my-4" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default React.memo(Data);
